import { GeneratorMobileIcon } from './GeneratorMobileIcon';

/**
 * author: Michael Richins
 * id D97956CD-8749-401C-A45B-04D6D20017A9
 * name generator-mobile
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/generator-mobile.svg
 * tags
 * - Home Automation 
 * - Transportation + Other 
 */
export const ElectricityGeneratorIcon = GeneratorMobileIcon;
export default ElectricityGeneratorIcon